import { ArrowLeftCircle } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconArrowLeftCircle12Line = createIcon(
  ArrowLeftCircle,
  12,
  "Line"
);
export const IconArrowLeftCircle16Line = createIcon(
  ArrowLeftCircle,
  16,
  "Line"
);
export const IconArrowLeftCircle20Line = createIcon(
  ArrowLeftCircle,
  20,
  "Line"
);
export const IconArrowLeftCircle24Line = createIcon(
  ArrowLeftCircle,
  24,
  "Line"
);
export const IconArrowLeftCircle32Line = createIcon(
  ArrowLeftCircle,
  32,
  "Line"
);
export const IconArrowLeftCircle48Line = createIcon(
  ArrowLeftCircle,
  48,
  "Line"
);
export const IconArrowLeftCircle64Line = createIcon(
  ArrowLeftCircle,
  64,
  "Line"
);
